import { useSelector } from 'react-redux';

import { AEMContentProvider, AemFeature, createAemUrl } from '@app/components/AdobeExperienceFragments';
import { selectLocale, selectUserInfo } from '@app/redux';
import { selectConfig } from '@app/redux/config';

import { GetPlanOffersPayload } from '@mfe/shared/schema-types';

const BroadbandLabel = ({ plan }: { plan: GetPlanOffersPayload }) => {
  const {
    locale: { userLocale },
  } = useSelector(selectLocale);

  const {
    userInfo: { accountType },
  } = useSelector(selectUserInfo);

  const { aemBaseUrl } = useSelector(selectConfig);

  return (
    <AEMContentProvider
      src={createAemUrl({
        baseUrl: aemBaseUrl,
        locale: userLocale,
        feature: AemFeature.PLAN_LABEL,
        accountType,
        additionalSelectors: ['pidi'],
        suffixes: {
          upi: plan.characteristics.upi ?? null,
          serviceAreaId: plan.characteristics.serviceAreaId ?? null,
          offerId: plan.offerId,
        },
      })}
      id={`plan-label-${plan.characteristics.offerName}`}
      style={{ textAlign: 'left' }}
    />
  );
};

export default BroadbandLabel;
